import { Directive, ElementRef, HostListener, Input, NgZone, OnDestroy, Renderer2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[usbScrollToTopDirective]'
})
export class ScrollToTopDirectiveDirective implements OnDestroy {
  @Input() showAfter: number = 100;
  private button: HTMLElement;
  private navigationSubscription: Subscription;

  constructor(
    private el: ElementRef,
    private ngZone: NgZone,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.button = this.renderer.createElement('button');
    this.renderer.setStyle(this.button, 'position', 'fixed');
    this.renderer.setStyle(this.button, 'bottom', '20px');
    this.renderer.setStyle(this.button, 'right', '20px');
    this.renderer.setStyle(this.button, 'border', '0');
    this.renderer.setStyle(this.button, 'font-size', '40px');
    this.renderer.setStyle(this.button, 'background', 'none');
    this.renderer.setStyle(this.button, 'outline', 'none');
    this.renderer.setStyle(this.button, 'box-shadow', 'none');
    this.renderer.setStyle(this.button, 'display', 'none'); // Inicialmente oculto
    this.renderer.setProperty(this.button, 'innerHTML', '<i class="bi bi-arrow-up-circle-fill"></i>');
    this.renderer.listen(this.button, 'click', () => this.scrollToTop());
    this.renderer.appendChild(document.body, this.button);

    // El botón se crea a mano y se cuelga de document.body (fuera del árbol de vistas de
    // Angular), así que al destruirse el componente que trae la directiva Angular no lo saca
    // solo del DOM. Además, navegar con un link/routerLink usa pushState (no dispara
    // 'popstate'), así que antes quedaba pegado en pantalla al volver al home estando scrolleado.
    // Escuchamos NavigationStart para ocultarlo apenas arranca cualquier navegación.
    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.renderer.setStyle(this.button, 'display', 'none');
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const yOffset = window.pageYOffset;
    if (yOffset > this.showAfter) {
      this.renderer.setStyle(this.button, 'display', 'block');
    } else {
      this.renderer.setStyle(this.button, 'display', 'none');
    }
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
    this.button?.remove();
  }

  private scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
